import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useInfiniteQuery } from '@tanstack/react-query';
import { IImageListItem } from '@types';

async function getUsedImageList(params: { pageParam: number }): Promise<AxiosResponse<FetchResult<IImageListItem[]>>> {
  const response = await instance.get(`/images/used-images?page=${params.pageParam}&take=21`);
  return response;
}

const useFetchUsedImageList = () => {
  const {
    data,
    fetchNextPage,
    fetchPreviousPage,
    hasNextPage,
    hasPreviousPage,
    isFetchingNextPage,
    isFetchingPreviousPage,
    promise,
    isLoading,
    isFetching,
    ...result
  } = useInfiniteQuery({
    queryKey: ['get', `/images/used-images`],
    queryFn: ({ pageParam }) => getUsedImageList({ pageParam }),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => {
      if (lastPage.data.meta && lastPage.data.meta.hasNextPage) {
        return lastPage.data.meta.page + 1;
      } else {
        return null;
      }
    },
    retry: false,
    refetchOnWindowFocus: false
  });

  return {
    data,
    fetchNextPage,
    fetchPreviousPage,
    hasNextPage,
    hasPreviousPage,
    isFetchingNextPage,
    isFetchingPreviousPage,
    promise,
    isLoading,
    isFetching,
    ...result
  };
};

export default useFetchUsedImageList;
